
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      var date = new Date();
var TommorowDay = date.setDate(date.getDate() + 1);
var Yesterday = date.setDate(date.getDate() - 1);
import $$ from "Dom7";
import actions from "../js/actions.js";
import URLS from "../js/Urls.js";

var moment = require("moment");

export default {
  data: function () {
    return {
      Block: {},
      BlockedRoomsComments: {},
      BlockedRooms: {},
      loginobject: {}
    };
  },
  methods: {},
  on: {
    pageInit: async function (e, page) {
      var self = this;
      var $ = self.$;
      var loginobject = actions.LoginGetResult();
      const blockId = page.route.params.BlockID; //get block details

      try {
        app.f7.preloader.show();
        await app.f7.request.promise.postJSON(URLS.GetBlockDetails, {
          BlockID: blockId,
          PropertyID: loginobject.PropertyID
        }).then(res => {
          self.$setState({
            Block: res.data
          });
          app.f7.preloader.hide();
        });
      } catch (e) {
        console.error("GetBlockDetails error:", e);
        app.f7.preloader.hide();
      }

      var today = moment();
      var tomorrow = today.clone().add(1, "days");
      $(".takecommentclass").on("change", function () {
        var blockedrooms = app.f7.smartSelect.get(".takecommentclass").getValue();
        blockedrooms = blockedrooms.replaceAll("_", " ");
        $("#blocktext").val(blockedrooms);
      });
      var calendarRangeFrom = app.f7.calendar.create({
        inputEl: '#block-calendar-From',
        dateFormat: 'dd/mm/yyyy',
        value: [moment().toDate()],
        closeOnSelect: true,
        disabled: [{
          from: new Date(1900, 0, 1),
          to: moment().subtract(1, 'day').toDate()
        }],
        on: {
          close: function () {
            handleDateChange();
          }
        }
      });
      var calendarRangeTo = app.f7.calendar.create({
        inputEl: '#block-calendar-To',
        dateFormat: 'dd/mm/yyyy',
        value: [moment().add(1, 'day').toDate()],
        closeOnSelect: true,
        disabled: [{
          from: new Date(1900, 0, 1),
          to: moment().subtract(1, 'day').toDate()
        }],
        on: {
          close: function () {
            handleDateChange();
          }
        }
      });
      $$('#block-calendar-From').on('click', function () {
        calendarRangeFrom.open();
      });
      $$('#block-calendar-To').on('click', function () {
        calendarRangeTo.open();
      });

      function handleDateChange() {
        var checkinValue = $("#block-calendar-From").val();
        var checkoutValue = $("#block-calendar-To").val();
        var checkinDate = moment(checkinValue, "DD/MM/YYYY", true);
        var checkoutDate = moment(checkoutValue, "DD/MM/YYYY", true);

        if (!checkinDate.isValid() || !checkoutDate.isValid()) {
          console.warn("Invalid date(s), skipping update");
          return;
        }

        if (checkinDate.isSameOrAfter(checkoutDate)) {
          checkinDate.add(1, 'days');
          checkoutDate = moment(checkinDate);
          calendarRangeTo.setValue([checkoutDate.toDate()]);
        }

        const disabledTo = checkinDate.clone().subtract(1, 'day');

        if (disabledTo.isValid()) {
          calendarRangeTo.params.disabled = [{
            from: new Date(1900, 0, 1),
            to: disabledTo.toDate()
          }];
          calendarRangeTo.update();
        } else {
          console.warn("disabledTo produced invalid date, skipping update");
        }
      }

      function getCalendarDate(calendarInstance, inputSelector) {
        let val = calendarInstance.getValue();
        if (Array.isArray(val)) val = val[0];

        if (!val) {
          const str = $$(inputSelector).val();
          const m = moment(str, 'DD/MM/YYYY', true);
          if (m.isValid()) val = m.toDate();
        }

        return val; // either Date or undefined
      }

      async function BlockedRooms(PropertyID, DateFrom, DateTo) {
        DateFrom = new Date(DateFrom[0]);
        DateTo = new Date(DateTo[0]);
        var DateFromstr = moment(DateFrom).format("YYYY-MM-DD");
        var DateTostr = moment(DateTo).format("YYYY-MM-DD");
        var perm = 0;
        let login = JSON.parse(localStorage.getItem("loginJson"));
        var obj = {
          PropertyID: PropertyID,
          DateFrom: DateFromstr,
          DateTo: DateTostr,
          UserID: login.UserID
        };
        await app.f7.request.promise.postJSON(URLS.GetRoomsForBlock, {
          obj
        }).then(res => {
          app.f7.preloader.hide();
          res.data.RoomsList.forEach(r => {
            r.Selected = r.Key == self.Block.RoomNumber;
          });
          self.$setState({
            BlockedRooms: res.data
          });
        });
      }

      $$(document).on('smartselect:change', '#smartselectBlockedRooms', function (e) {
        const rooms = app.f7.smartSelect.get('#smartselectBlockedRooms').getValue();
        const selected = self.BlockedRooms.RoomsList.find(r => r.Key == rooms);

        if (selected) {
          $$('#smartselectBlockedRooms .item-title').text(selected.Val);
        }
      });
      BlockedRooms(loginobject.PropertyID, calendarRangeFrom.getValue(), calendarRangeTo.getValue());

      if (self.Block && self.Block.DateFrom) {
        const df = moment(self.Block.DateFrom, 'DD/MM/YYYY', true);
        if (df.isValid()) calendarRangeFrom.setValue([df.toDate()]);
      }

      if (self.Block && self.Block.DateTo) {
        const dt = moment(self.Block.DateTo, 'DD/MM/YYYY', true);
        if (dt.isValid()) calendarRangeTo.setValue([dt.toDate()]);
      }

      $$('#UpdateRooms').on('click', async function () {
        const dateFrom = getCalendarDate(calendarRangeFrom, '#block-calendar-From');
        const dateTo = getCalendarDate(calendarRangeTo, '#block-calendar-To');

        if (!dateFrom || !dateTo) {
          app.f7.toast.create({
            text: 'Please select valid dates',
            closeTimeout: 1500
          }).open();
          return;
        }

        const CalendarDateFromStr = moment(dateFrom).format('DD/MM/YYYY');
        const CalendarDateToStr = moment(dateTo).format('DD/MM/YYYY');
        var comment = $$('textarea').val();
        var rooms = app.f7.smartSelect.get('#smartselectBlockedRooms').getValue();
        var postData = {
          RoomBlockedDayID: blockId,
          RoomID: rooms,
          DateFromString: CalendarDateFromStr,
          DateToString: CalendarDateToStr,
          PropertyID: loginobject.PropertyID,
          Notes: loginobject.UserID,
          OutOfOrderComment: comment
        };

        try {
          app.f7.preloader.show();
          const res = await app.f7.request.promise.post(URLS.SubmitRoomBlockedDayMain + '?f=app', postData);
          app.f7.preloader.hide();
          let data = res.data || res;

          if (typeof data === 'string') {
            data = data.replace(/^"+|"+$/g, '').trim();
          }

          if (data === 'ok' || data === 'Ok') {
            app.f7.toast.create({
              text: 'Rooms blocked successfully',
              closeTimeout: 2000,
              cssClass: 'toast_green'
            }).open();
          } else if (data === 'unblock') {
            app.f7.toast.create({
              text: 'Rooms unblocked successfully',
              closeTimeout: 2000,
              cssClass: 'toast_green'
            }).open();
          } else if (data === 'CantBlock') {
            app.f7.toast.create({
              text: 'Error blocking rooms',
              closeTimeout: 2000,
              cssClass: 'toast_red'
            }).open();
          } else {
            app.f7.toast.create({
              text: 'Unexpected response: ' + JSON.stringify(data),
              closeTimeout: 2000,
              cssClass: 'toast_red'
            }).open();
          }
        } catch (err) {
          app.f7.preloader.hide();
          console.error(err);
          app.f7.toast.create({
            text: 'Request failed: ' + err.status,
            closeTimeout: 2000,
            cssClass: 'toast_red'
          }).open();
        }
      });
    }
  },
  id: '77414aaa74',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n    <div class="page" data-name="new-reservation-home">\r\n        <!-- Top Navbar -->\r\n\r\n        <!-- Top Navbar -->\r\n        <div class="navbar">\r\n            <div class="navbar-bg"></div>\r\n            <div class="navbar-inner sliding">\r\n                <div class="left">\r\n                    <a class="link back">\r\n                        <i class="icon icon-back"></i>\r\n                    </a>\r\n                </div>\r\n                <div class="title" id="NewResBlockTitle">Block</div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class="page-content newreservationpage">\r\n            <div class="page-content" id="blockrooms-tab">\r\n                <!-- Dates -->\r\n                <div class="block-title" style="margin-top: 0;">Dates</div>\r\n                <div class="block">\r\n                    <div class="row">\r\n                        <span class="col-50 customcol">\r\n                            <input id="block-calendar-From" class="custom-input input-with-value" type="text" readonly\r\n                                value="';
      r += c(ctx_1.Block?.DateFrom, ctx_1);
      r += '" />\r\n                        </span>\r\n                        <div class="chip-media" style="position: absolute; right: 46%; background-color: #3478f5">\r\n                            <span class="material-icons"> chevron_right </span>\r\n                        </div>\r\n                        <span class="col-50 customcol">\r\n                            <input id="block-calendar-To" class="custom-input input-with-value" type="text" readonly\r\n                                value="';
      r += c(ctx_1.Block?.DateTo, ctx_1);
      r += '" />\r\n                        </span>\r\n                    </div>\r\n                </div>\r\n                <div class="block-title">Room Number</div>\r\n                <div class="block">\r\n                    <div class="row">\r\n                        <span class="col-100 customcol">\r\n                            <a href="#" class="item-link smart-select smart-select-init" id="smartselectBlockedRooms"\r\n                                data-open-in="popup">\r\n                                <select name="blockedRoom" id="blockedRoom">\r\n                                    ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.BlockedRooms.RoomsList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                                    <option value="';
          r += c(ctx_2.Key, ctx_2);
          r += '" ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.Selected, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'selected';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '>';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>\r\n                                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                                </select>\r\n                                <div class="item-content">\r\n                                    <div class="item-inner">\r\n                                        <div class="item-title">\r\n                                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.BlockedRooms.RoomsList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                                            ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.BlockedRooms.RoomsList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                                            ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.Selected, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += c(ctx_4.Val, ctx_4);
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\r\n                                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                                            Blocked Room\r\n                                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </a>\r\n                        </span>\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- Blocked Room Comments -->\r\n                <div class="block-title">Blocked Room Comments</div>\r\n                <div class="block">\r\n                    <div class="row">\r\n                        <span class="col-100 customcol">\r\n                            <a href="#" class="item-link smart-select smart-select-init takecommentclass"\r\n                                data-open-in="popup">\r\n                                <select name="blockedComment" id="blockedComment">\r\n                                    <option value="';
      r += c(ctx_1.Block?.BlockRoomReason, ctx_1);
      r += '" selected>';
      r += c(ctx_1.Block?.BlockRoomReason, ctx_1);
      r += '\r\n                                    </option>\r\n                                </select>\r\n                                <div class="item-content">\r\n                                    <div class="item-inner">\r\n                                        <div class="item-title">Blocked Room Comments</div>\r\n                                    </div>\r\n                                </div>\r\n                            </a>\r\n                        </span>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="block-title">Comments</div>\r\n                <div class="block">\r\n                    <div class="row">\r\n                        <span class="col-100 customcol">\r\n                            <textarea class="resizable" id="blocktext" placeholder=""\r\n                                style="width: 100%; padding-left: 5px; padding-right: 5px">';
      r += c(ctx_1.Block?.Comments, ctx_1);
      r += '</textarea>\r\n                        </span>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="block">\r\n                    <div class="row">\r\n                        <div class="col-70">\r\n                            <button class="col button button-outline color-blue" id="UpdateRooms">Update Room\r\n                                Status</button>\r\n                        </div>\r\n                        <div class="col-30">\r\n                            <button id="cancelbtn" class="col button button-fill cancelreserv">Cancel</button>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n';
      return r;
    }(this);
  },

  style: `
    .custom-stepper-wrapper {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }

    .custom-stepper-buttons-wrapper {
        display: flex;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        border-radius: 5px;
    }

    .custom-stepper-btn {
        background: none;
        border: 1px solid rgba(0, 0, 0, 0.12);
        font-size: 17px;
        color: rgb(0, 122, 255);
        font-weight: 700;
        width: 40px;
        line-height: 26px;
        transition-duration: 0.2s;
    }

    .custom-stepper-btn.custom-plus {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .custom-stepper-btn.custom-minus {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }


    .customcol {
        background-color: #ebebeb;
        line-height: 35px;
        border-radius: 5px;
    }

    .Div_title {
        position: relative;
        overflow: hidden;
        margin: 0;
        white-space: var(--f7-block-title-white-space);
        text-overflow: ellipsis;
        text-transform: var(--f7-block-title-text-transform);
        color: var(--f7-block-title-text-color);
        font-size: var(--f7-block-title-font-size, inherit);
        font-weight: var(--f7-block-title-font-weight);
        line-height: var(--f7-block-title-line-height);
        margin-top: 0px;
        margin-bottom: var(--f7-block-title-margin-bottom);
        margin-left: 0px;
        margin-right: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-right));
    }

    .item-after {
        padding-left: 0px;
        padding-right: 0px;
    }

    .newreservationpage .button-fill {
        background-color: #0077ca;
    }

    .tab-link-active {
        color: #0077ca !important;
    }

    .steps {
        display: inline-block;
        text-align: center;
        color: #0077ca;
        width: 100%;
        font-size: 16px;
        font-weight: 700;
    }

    .step {
        display: inline-block;
        width: 100%;
        text-align: center;
    }

    .material-icons {
        vertical-align: middle;
    }

    .rooms-not-availiable .room-price-cnt .custom-badge {
        background-color: red;
    }

    .custom-input.input-with-value {
        color: #3478f5 !important;
    }
`,
  styleScoped: false
};
    